<template>
  <div class="tv-list">
    <JumpHeader />
    <div class="list-wrapper">
      <div
        class="list-item"
        v-for="(item, index) in programList"
        :key="index"
        @click="handleClickProgramItem(item)"
      >
        <div class="img-wrapper">
          <img class="img-class" :src="item.pictureUrl" alt="" />
          <van-icon class="play-icon" name="play" />
        </div>
        <div class="info-wrapper">
          <div class="tv-name">{{ item.information }}</div>
          <div class="cur-play">正在播出：{{ item.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import JumpHeader from "@/components/Base/JumpHeader";
import { queryProgramList } from "@/http/api";
import wxSdk from "@/http/wxApi.js";
import { getMobilsInfo } from "@/utils";

export default {
  name: "TvList",
  components: {
    JumpHeader,
  },
  data() {
    return {
      programList: [],
    };
  },
  mounted() {
    this.getListData();
    this.wxShare();
  },
  methods: {
    getListData() {
      queryProgramList({
        type: 1,
      }).then((res) => {
        console.log(res);
        this.programList = res.data;
      });
    },
    handleClickProgramItem(item) {
      this.$router.push({
        name: "tvDetail",
        query: {
          code: item.code,
        },
      });
    },
    wxShare() {
      wxSdk.getJSSDK({
        title: "花城+电视直播",
        desc: "花城+",
        linkurl: `${process.env.VUE_APP_SHARE_URL}/plusshare/#/tvList`,
        img: `${process.env.VUE_APP_SHARE_URL}/filedata/default/hcplusIcon.jpg`,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.tv-list {
  width: 100%;

  .list-wrapper {
    margin-top: 60px;
    .list-item {
      width: 100%;
      box-sizing: border-box;
      padding: 0 15px;
      margin-bottom: 15px;

      .img-wrapper {
        position: relative;
        width: 100%;
        height: 100%;
        border-radius: 8px;
        overflow: hidden;

        .img-class {
          width: 100%;
          height: 100%;
        }

        .play-icon {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 80px;
          color: rgba(255, 255, 255, 0.9);
        }
      }

      .info-wrapper {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 5px;

        .tv-name {
          font-size: 16px;
          color: #555 !important;
        }

        .cur-play {
          font-size: 12px;
          color: #999 !important;
        }
      }
    }
  }
}
</style>
